import { apiClient } from './setupApi';

const userRoles = '/user/roles';

export const requestGetRoles = async () => {
  const { data } = await apiClient.get(userRoles);
  return data;
};

export const requestSetRoles = async (id, payload) => {
  const { data } = await apiClient.patch(`${userRoles}/${id}/permission`, payload);
  return data;
};
